import { render } from "./garment-measurements-tab.vue?vue&type=template&id=4c14ee08"
import script from "./garment-measurements-tab.vue?vue&type=script&lang=js"
export * from "./garment-measurements-tab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__